import { Typography } from "@repo/design-system";
import type { ICellValue } from "@/api/molecularData";
import {
  MAX_ARRAY_LINES,
  isArrayValue,
  isLinkValue,
  truncate,
} from "../helpers";

interface ICellContentProps {
  colKey: string;
  value: ICellValue;
}

export function CellContent({ colKey, value }: ICellContentProps) {
  if (isArrayValue(value)) {
    const items = value as (string | number)[];
    const capped = items.length > MAX_ARRAY_LINES;
    const displayed = capped ? items.slice(0, MAX_ARRAY_LINES - 1) : items;
    return (
      <div className="flex flex-col gap-1 py-0.5">
        {displayed.map((item, i) => (
          <Typography
            key={i}
            variant="paragraph-m-regular"
            className="whitespace-nowrap text-contentPrimary">
            {truncate(String(item ?? "—"))}
          </Typography>
        ))}
        {capped && (
          <Typography
            variant="paragraph-m-regular"
            className="text-contentTertiary">
            …
          </Typography>
        )}
      </div>
    );
  }

  if (isLinkValue(value)) {
    return (
      <a
        href={value.link}
        target="_blank"
        rel="noopener noreferrer"
        className="cursor-pointer"
        onClick={(e) => e.stopPropagation()}>
        <Typography
          variant="paragraph-m-semibold"
          className="whitespace-nowrap text-contentBrand underline-offset-2 hover:underline text-b500">
          {truncate(value.id)}
        </Typography>
      </a>
    );
  }

  if (colKey === "SMILES") {
    return (
      <Typography
        variant="paragraph-m-regular"
        className="whitespace-nowrap text-contentPrimary">
        {truncate(String(value ?? "—"))}
      </Typography>
    );
  }

  return (
    <Typography
      variant="paragraph-m-regular"
      className="whitespace-nowrap text-contentPrimary">
      {truncate(String(value ?? "—"))}
    </Typography>
  );
}
